import React from 'react';
import FormSelectBox from '../../../../components/Form/FormSelectBox';
import { ContratistaTrabajoEmpresa } from '../../../../types/ContratistaTrabajoEmpresa';

// CU13 (mantis 0200062): mostrar estado de habilitación debajo de razón social
const buildEtiquetaHabilitacion = (
  c: ContratistaTrabajoEmpresa
): string =>
  c.nombreEstadoHabilitacion
    ? `Habilitación ${c.nombreEstadoHabilitacion}`
    : 'Sin Habilitación';

interface InicioPorTipoTrabajoProps {
  trabajosEmpresa: any[];
  idTrabajoEmpresa: string;
  contratistas: ContratistaTrabajoEmpresa[];
  onChangeTrabajoEmpresa: (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => void;
  onSelectContratista: (
    contratista: ContratistaTrabajoEmpresa
  ) => void;
}

export const InicioPorTipoTrabajo: React.FC<
  InicioPorTipoTrabajoProps
> = ({
  trabajosEmpresa,
  idTrabajoEmpresa,
  contratistas,
  onChangeTrabajoEmpresa,
  onSelectContratista,
}) => {
  return (
    <>
      <div className="d-flex justify-content-center">
        <FormSelectBox
          title={'Tipo de Trabajo'}
          label={'tipo de trabajo'}
          id={'tipoTrabajo'}
          name={'idTrabajoEmpresa'}
          onChange={onChangeTrabajoEmpresa}
          optionId={'id'}
          optionLabel={'tipoTrabajo'}
          value={idTrabajoEmpresa}
          options={trabajosEmpresa}
          classLabel="col-form-label col-2 text-left"
          classDivSelect="col-8"
          styleLabelColor="black"
        />
      </div>
      <div className="row mt-3">
        <label className="col-form-label">Contratistas</label>

        <div className="ms-2 p-3 card p-5">
          <div className="row">
            {contratistas && contratistas.length > 0 ? (
              contratistas.map(
                (contratista: ContratistaTrabajoEmpresa) => {
                  return (
                    <div
                      className="col-3 text-center"
                      key={contratista.id}
                      data-testid={`card-contratista-${contratista.id}`}
                    >
                      <a
                        href="/contratista"
                        onClick={(e) => {
                          e.preventDefault();
                          onSelectContratista(contratista);
                        }}
                      >
                        {contratista.logo ? (
                          <img
                            src={`data:image/jpeg;base64,${contratista.logo}`}
                            alt={contratista.razonSocial}
                            width="100"
                            height="100"
                          />
                        ) : (
                          <div
                            style={{
                              width: '100px',
                              height: '100px',
                              backgroundColor: '#f0f0f0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              margin: '0 auto',
                            }}
                          >
                            <span>Sin logo</span>
                          </div>
                        )}
                        <br />
                        <span className="fs-9">
                          {contratista.razonSocial}
                        </span>
                        <br />
                        <span
                          className="fs-9 text-muted"
                          data-testid={`estado-habilitacion-${contratista.id}`}
                        >
                          {buildEtiquetaHabilitacion(contratista)}
                        </span>
                      </a>
                    </div>
                  );
                }
              )
            ) : (
              <div className="col-12 text-center">
                <p className="text-muted">
                  {idTrabajoEmpresa
                    ? 'No hay contratistas disponibles para este tipo de trabajo'
                    : 'Seleccione un tipo de trabajo para ver los contratistas disponibles'}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
